import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { decode, encode } from 'base-64';
import { refreshAuthLogic } from './refresh-token';

export const baseURL = process.env.REACT_APP_API_URL;

if (!global.btoa) {
  global.btoa = encode;
}

if (!global.atob) {
  global.atob = decode;
}

export const basicUser = 'myusername';
export const basicPass = 'password123';
const authHeader = `Basic ${encode(`${basicUser}:${basicPass}`)}`;

const api = axios.create({
  baseURL,
});

api.interceptors.request.use(async config => {
  const headers = {
    ...config.headers,
  };
  const token = await localStorage.getItem('token');

  headers.Authorization = !headers.noAuth ? `Bearer ${token}` : authHeader;
  headers.Accept = 'application/json';

  return {
    ...config,
    headers,
  };
});

createAuthRefreshInterceptor(api, refreshAuthLogic);

export default api;
